import {orderList1, orderList2} from '@/api/index.js'
import {router, vm} from '@/main.js'

const state = {
  initPage: {
    startTime: '',
    endTime: '',
    orderNo: '',
    orderStatus: '',
    page: 1,
    size: 10,
    count: 0,
    cusUserId: '',
    orderStatusOnline: ''
  },
  resetPage: {
    startTime: '',
    endTime: '',
    orderNo: '',
    orderStatus: '',
    page: 1,
    size: 10,
    count: 0,
    cusUserId: '',
    orderStatusOnline: ''
  },
  orderStatusList: [
    {label: "下单成功", value: "2"},
    {label: "生产中", value: "3"},
    {label: "已发货", value: "4"},
    {label: "完成收货", value: "5"}
  ],
  tableData: [],
  //活动
  activity: {
    activityTimer: false, //活动有效期
    indexImg: "", //首页活动图片
    orderListImg: "" //订单列表活动图片
  }
};

const getters = {};

const mutations = {
  orderDraftMutations(state) {
    state.tableData = []
    state.initPage = state.resetPage
    state.initPage.cusUserId = JSON.parse(sessionStorage.getItem('loginInfo')).cusUserId
    state.resetPage.cusUserId = JSON.parse(sessionStorage.getItem('loginInfo')).cusUserId
    state.initPage.orderStatus = 9;
    orderList2(state.initPage).then(res => {
      state.tableData = res.data.rows;
      state.initPage.count = res.data.count
    })
  },
  orderList3Mutations(state) {
    state.tableData = []
    state.initPage = state.resetPage
    state.initPage.cusUserId = JSON.parse(sessionStorage.getItem('loginInfo')).cusUserId
    state.resetPage.cusUserId = JSON.parse(sessionStorage.getItem('loginInfo')).cusUserId
    orderList2(state.initPage).then(res => {
      state.tableData = res.data.rows;
      state.initPage.count = res.data.count
    })
  },
  orderList4Mutations(state) {
    state.tableData = []
    state.initPage = state.resetPage
    state.initPage.cusUserId = JSON.parse(sessionStorage.getItem('loginInfo')).cusUserId
    state.resetPage.cusUserId = JSON.parse(sessionStorage.getItem('loginInfo')).cusUserId
    orderList2(state.initPage).then(res => {
      state.tableData = res.data.rows;
      state.initPage.count = res.data.count
    })
  },
  setOrderIdMutations(state, id) {
    sessionStorage.setItem('orderDetailId', id);
    // state.initPage.cusUserId = id;
    router.push('/OrderList/OrderList1Detail')
  },
  setOrderId4Mutations(state, id) {
    sessionStorage.setItem('orderDetailId', id);
    // state.initPage.cusUserId = id;
    router.push('/OrderList/OrderList4Detail')
  },
  activityMutations(state, show) {
    let indexImg = require('@/assets/images/ai-home.jpg'),  //首页日常图片
      orderListImg = require('@/assets/images/banner2.png'),  //订单列表日常图片
      activityIndexImg = require('@/assets/images/yd2.jpg'),  //活动首页图片
      activityOrderListImg = require('@/assets/images/banner2.png');  //活动订单列表图片

    state.activity.activityTimer = show;
    state.activity.indexImg = show ? activityIndexImg : indexImg;
    state.activity.orderListImg = show ? activityOrderListImg : orderListImg;
  }
};

const actions = {
  orderDraftActions(context) {
    context.commit('orderDraftMutations')
  },
  setOrderIdActions(context, id) {
    context.commit('setOrderIdMutations', id)
  },
  orderList4Actions(context) {
    context.commit('orderList4Mutations')
  },
  setOrderId4Actions(context, id) {
    context.commit('setOrderId4Mutations', id)
  },
  activityActions(context, show) {
    context.commit('activityMutations', show)
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/orderList.js